import React from "react";
import { Button, Group, Text } from "@mantine/core";

const defaultFilters = [
  "All",
  "Errors",
  "Warns",
  "Info",
  "Screens",
  "Events",
  "State",
  "xhr",
  "Exceptions",
];

const Filter = ({ onClick, active = "All", data = defaultFilters }) => {
  return (
    <div className="filter-strip">
      <Text className="filter-strip__label">Filters</Text>
      <Group spacing={8}>
        {data.map((title) => (
          <Button
            key={title}
            compact
            variant="subtle"
            className={`filter-chip ${active === title ? "filter-chip--active" : ""}`}
            onClick={() => onClick(title)}
          >
            {title === "xhr" ? "HTTP" : title}
          </Button>
        ))}
      </Group>
    </div>
  );
};

export default Filter;
